import { CommonGet, CommonPost, CommonGetIDServer, CommonPostIDServer } from "../../../utils/CommonFetch";

export default {
    GetAllCollectionPoints,
    getAllOperationEntitiesForDropDown,
    getGroupByCollectionCatagoryID,
    getMobilemenuCollectionCatagoryFilterData,
    AddMobilemenuCollectionCatagory,
    getAvialableMobileMenus,
    EditMobilemenuCollectionCatagory,
    getCollectionCategoryByOperationentity,
    getAllMenuVerificationTypes,
    getUsedMobileMenus,
    EditMapping
};

async function getMobilemenuCollectionCatagoryFilterData(data) {
    var filterModel = {
        collectionCatagoryID: data.collectionCategoryID
    }
    const response = await CommonPost('/api/MobileMenuCollectionCategoryMapping/GetMobileMenuCollectionCategorryFilter', null, filterModel);
    return response.data;
}

async function AddMobilemenuCollectionCatagory(data) {
    let mobilemenuCollectionCatagory = {
        collectionCategoryMenuID: 0,
        mobileMenuID: parseInt(data.mobileMenuID),
        collectionCategoryID: parseInt(data.collectionCategoryID),
        primaryMenuVerificationTypeID: parseInt(data.primaryMenuVerificationTypeID),
        secondaryMenuVerificationTypeID: parseInt(data.secondaryMenuVerificationTypeID),
        isActive: data.isActive,
        collectionTagEnabled: data.collectionTagEnabled,
        digitalScaleEnabled: data.digitalScaleEnabled,
        createdBy: 0,
        createdDate: new Date().toISOString(),
        modifiedBy: 0,
        modifiedDate: new Date().toISOString()
    }

    var response = await CommonPost('/api/MobileMenuCollectionCategoryMapping/AddMobileMenuCollectionCategorry', null, mobilemenuCollectionCatagory);
    return response;
}

async function EditMobilemenuCollectionCatagory(collectionCategoryMenuID) {
    var response = await CommonGet('/api/MobileMenuCollectionCategoryMapping/DisableCollectionCategoryMenu', 'collectionCategoryMenuID=' + collectionCategoryMenuID);
    return response;
}

async function EditMapping(formData, collectionCategoryMenuID) {
    let mobilemenuCollectionCatagory = {
        collectionCategoryMenuID: collectionCategoryMenuID,
        isActive: formData.isActive,
        collectionTagEnabled: formData.collectionTagEnabled,
        digitalScaleEnabled: formData.digitalScaleEnabled
    }

    var response = await CommonPost('/api/MobileMenuCollectionCategoryMapping/EditMapping', null, mobilemenuCollectionCatagory);
    return response;
}

async function GetAllCollectionPoints(id, groupID) {
    var collectionPointArray = [];
    const response = await CommonGet('/api/CollectionPoint/GetAllCollectionPoint', null);
    for (let item of Object.entries(response.data)) {
        if (item[1] !== undefined && item[1]["operationEntityID"] === id && item[1]["groupID"] === parseInt(groupID) && item[1]["isActive"] === true) {
            collectionPointArray[item[1]["collectionPointID"]] = item[1]["collectionPointName"]
        }
    }
    return collectionPointArray;
}

async function getAllOperationEntitiesForDropDown(id) {
    var operationEntityArray = [];
    var response = await CommonGet('/api/OperationEntity/GetAllOperationEntities', null);
    for (let item of Object.entries(response.data)) {
        if (item[1] !== undefined && item[1]["groupID"] === parseInt(id) && item[1]["isActive"] === true)
            operationEntityArray[item[1]["operationEntityID"]] = item[1]["operationEntityName"];
    }
    return operationEntityArray;
}

async function getGroupByCollectionCatagoryID(collectionCatagoryID) {
    var response = await CommonGet('/api/OpearationentityCollectionCatagoryMapping/GetGroupByCollectionCatagory', 'ID=' + collectionCatagoryID);
    return response.data;
}

async function getAvialableMobileMenus(collectionCategoryID) {
    var mobileMenuArray = [];
    var response = await CommonGet('/api/MobileMenuCollectionCategoryMapping/GetUnMappedMobileMenus', 'collectionCategoryID=' + collectionCategoryID);
    for (let item of Object.entries(response.data)) {
        mobileMenuArray[item[1]["mobileMenuID"]] = item[1]["menuName"];
    }
    return mobileMenuArray;
}

async function getUsedMobileMenus(collectionCategoryID) {
    var mobileMenuArray = [];
    var response = await CommonGet('/api/MobileMenuCollectionCategoryMapping/GetMappedMobileMenus', 'collectionCategoryID=' + collectionCategoryID);
    for (let item of Object.entries(response.data)) {
        mobileMenuArray[item[1]["mobileMenuID"]] = item[1]["menuName"];
    }
    return mobileMenuArray;
}

async function getCollectionCategoryByOperationentity(operationEntityID) {
    var collectionCategorysArray = [];
    var response = await CommonGet('/api/CollectionCategory/GetCollectionCategoryByOperationEntityID', 'operationEntityID=' + operationEntityID);
    for (let item of Object.entries(response.data)) {
        collectionCategorysArray[item[1]["collectionCategoryID"]] = item[1]["collectionCategoryName"];
    }
    return collectionCategorysArray;
}

async function getAllMenuVerificationTypes() {
    var operationEntityArray = [];
    var response = await CommonGet('/api/MenuVerificationType/GetAllMenuVerificationTypes', null);
    for (let item of Object.entries(response.data)) {
            operationEntityArray[item[1]["menuVerificationTypeID"]] = item[1]["menuVerificationTypeName"];
    }
    return operationEntityArray;
}